import * as _ from "lodash";
import * as angular from "angular";

import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { PermissionCheck } from "../../shared/permission";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { Building } from "../../models/building.model";
import { House } from "../../models/house.model";
import { BuildingDataProvider } from "../../data-provider/building.dp";
import { HouseDataProvider } from "../../data-provider/house.dp";

let BuildingHousesComponent = {
    selector: "vcBuildingHouses",
    templateUrl: "/angular/components/building/building-houses.component.html",
    bindings: {
        building: "=",
        houses: "=?",
    },
    controller: class BuildingHousesController {
        private $scope: any;
        private $timeout: any;
        private __app_type: string;
        public __env: any;
        private dialog: DialogUtils;
        private toast: ToastUtils;
        private modelsUtils: any;
        public permissionProvider: PermissionCheck;
        private dataProvider: BuildingDataProvider;
        private houseDataProvider: HouseDataProvider;

        public building: Building;
        public isLeaderView: boolean;
        public essentialsMode: boolean;
        public houses: Array<House>;
        public floorHouses: any;
        public loading = false;

        constructor(
            $scope: any,
            $timeout: object,
            __app_type: string,
            __env: any,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            ModelsUtils: any,
            PermissionCheck: PermissionCheck,
            BuildingDataProvider: BuildingDataProvider,
            HouseDataProvider: HouseDataProvider,
            CampaignDataProvider: CampaignDataProvider
        ) {
            this.$scope = $scope;
            this.$timeout = $timeout;
            this.__app_type = __app_type;
            this.__env = __env;
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
            this.modelsUtils = ModelsUtils;
            this.permissionProvider = PermissionCheck;
            this.dataProvider = BuildingDataProvider;
            this.houseDataProvider = HouseDataProvider;
            this.isLeaderView = this.__app_type == "LEADER";
            this.essentialsMode =
                CampaignDataProvider.activeCampaign.campaignstatusid == "5";
        }

        $onInit() {
            if (!this.houses) {
                this.loadHouses();
            } else {
                this.floorHouses = this.houseDataProvider.sortHousesIntoFloors(
                    this.houses
                );
            }
        }

        loadHouses(): void {
            this.loading = true;

            this.houseDataProvider
                .building(this.building.id)
                .then((houses: House[]) => {
                    this.houses = houses;
                    this.floorHouses =
                        this.houseDataProvider.sortHousesIntoFloors(
                            this.houses
                        );
                    this.loading = false;
                });
        }

        openViewHouseDialog(house: House, ev: object): void {
            this.dialog
                .show({
                    component: "vc-view-house",
                    targetEvent: ev,
                    scope: this.$scope,
                    ariaLabel: "View House",
                    size: "large",
                    locals: {
                        selectedHouse: house,
                        selectedHid: null,
                    },
                })
                .then((data: object) => {
                    house.setData(data);
                });
        }

        deleteHouseDialog(house: House, ev: object): void {
            this.dialog
                .delete({
                    fullscreen: true,
                    targetEvent: ev,
                    multiple: true,
                    locals: {
                        bodyText:
                            "This action will permanently delete this house from your database. Any analytics associated with these contacts will also be deleted.",
                        title: "Delete House?",
                    },
                })
                .then(() => {
                    this.houseDataProvider.delete(house).then(() => {
                        this.toast.success("House deleted.");
                        this.loadHouses();
                    });
                });
        }

        openEditHouseDialog(house: House, ev: object): void {
            this.dialog
                .show({
                    component: "vc-house-form",
                    targetEvent: ev,
                    scope: this.$scope,
                    ariaLabel: "House",
                    locals: {
                        selectedHouse: house,
                    },
                    size: "large",
                })
                .then((data: object) => {
                    house.setData(data);
                    this.floorHouses =
                        this.houseDataProvider.sortHousesIntoFloors(
                            this.houses
                        );
                });
        }

        close(): void {
            this.dialog.hide(this.houses);
        }

        checkedHouses(): House[] {
            if (this.houses) {
                return this.houses.filter((house: House) => {
                    return house.checked == true;
                });
            }
            return [];
        }

        openEditFloorDialog(ev: object): void {
            this.dialog
                .show({
                    component: "vc-edit-floor",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        hids: this.checkedHouses().map(
                            (house: House) => house.hid
                        ),
                    },
                })
                .then((floor: string) => {
                    this.loading = true;
                    this.houseDataProvider
                        .editHouses({
                            hids: this.checkedHouses().map(
                                (house: House) => house.hid
                            ),
                            fields: {
                                hfloor: floor,
                            },
                        })
                        .then(() => {
                            this.loadHouses();
                            this.toast.success(
                                this.checkedHouses().map(
                                    (house: House) => house.hid
                                ).length + " houses edited successfully"
                            );
                        });
                });
        }

        openDeleteHousesDialog(ev: object): void {
            this.dialog
                .delete({
                    fullscreen: true,
                    targetEvent: ev,
                    multiple: true,
                    locals: {
                        bodyText:
                            "This action will permanently delete these house from this building AND your database. Any analytics associated with these houses/contacts will also be deleted.",
                        title:
                            "Delete " +
                            this.checkedHouses().length +
                            " Houses?",
                    },
                })
                .then(() => {
                    this.loading = true;
                    this.houseDataProvider
                        .deleteHouses(
                            this.checkedHouses().map((house) => house.hid)
                        )
                        .then(() => {
                            this.loadHouses();
                            this.toast.success(
                                this.checkedHouses().map(
                                    (house: House) => house.hid
                                ).length + " houses deleted successfully"
                            );
                        });
                });
        }

        uncheckAll(): void {
            _.forEach(this.houses, (house: House) => {
                house.checked = false;
            });
        }
    },
};

angular
    .module("building")
    .component(BuildingHousesComponent.selector, BuildingHousesComponent);
